import {
  createListAllQuery,
  getHabitat,
  GetHabitatQuery,
  GetHabitatQueryVariables,
  graphqlCall,
  Habitat,
  habitatByHabitatID,
  HabitatByHabitatIDQueryVariables,
  listHabitats,
  ListHabitatsQuery,
  ListHabitatsQueryVariables,
} from '@akin-home/amplify';

export const listHabitatsQuery = (params?: ListHabitatsQueryVariables) =>
  graphqlCall<ListHabitatsQuery>(listHabitats, params);

export const listAllHabitatsQuery = createListAllQuery<
  Habitat,
  ListHabitatsQueryVariables
>(listHabitats, 'listHabitats');

export const listHabitatsByHabitatId = createListAllQuery<
  Habitat,
  HabitatByHabitatIDQueryVariables
>(habitatByHabitatID, 'habitatByHabitatID');

/** At some point we should refactor this query to get habitat and user data in 1 fetch */
// `query HabitatByHabitatID(
//   $habitatID: String
//   $nextToken: String
// ) {
//   habitatByHabitatID(
//     habitatID: $habitatID
//     nextToken: $nextToken
//   ) {
//     items {
//       id
//       habitatID
//       name
//       imageID
//       image {
//         id
//         name
//         data {
//           bucket
//           region
//           key
//           __typename
//         }
//       }
//       imageURL
//     }
//     nextToken
//   }

//   userByHabitat(
//     habitatID: $habitatID
//     nextToken: $nextToken
//   ) {
//     items {
//       id
//       sub
//       name
//       location
//       username
//       primary
//       habitatID
//       role
//       email
//       phoneNumber
//       NDISAccountName
//       NDISNumber
//       birthday
//       planManagerName
//       planManagerEmail
//       emailVerified
//       carerPhone
//       carerName
//       supportWorkerPhone
//       supportWorkerName
//       contacts
//       favouriteContacts
//       address {
//         type
//         street
//         city
//         state
//         postcode
//         country
//         __typename
//       }
//       profileColor
//       profilePicture
//       imageID
//       image {
//         id
//         name
//         habitatID
//         readGroups
//         data {
//           bucket
//           region
//           key
//           __typename
//         }
//         thumbnail {
//           bucket
//           region
//           key
//           __typename
//         }
//         createdAt
//         updatedAt
//         __typename
//       }
//       customPictureURL
//       systemPreferences {
//         androidNotificationSoundID
//         androidAlarmSoundID
//         __typename
//       }
//       endpointIds
//       hasCompletedMealOnboarding
//       hasViewedMealSection
//       hasViewedGoalSection
//       recipePreferenceOptionIDs
//       onboardingToken
//       hasOnboarded
//       skippedOnboardingWizard
//       onboardingRecipeChoices
//       dashboardLayoutPreset
//       chatApplicationId
//       people
//       budget
//       time_and_effort
//       dietary_balance
//       allergies
//       prepTime
//       avoidances {
//         category
//         degree
//         __typename
//       }
//       skillLevel
//       is_child_profile
//       use_generative_ai {
//         name
//         model
//         max_tokens
//         temperature
//       }
//       favourite_recipe_ids
//       contact_id
//     }
//     nextToken
//   }
// }
// `,

export const getHabitatQuery = (params?: GetHabitatQueryVariables) =>
  graphqlCall<GetHabitatQuery>(getHabitat, params);
